class ProfetDinoTakeover {
	constructor() {
		this.foot = document.querySelector('#dinosaur-foot');
		this.dino = document.querySelector('#dino');
		this.crackedGlass = document.querySelectorAll('.cracked-glass-item');
		this.modalWrapper = document.querySelector('.dino-takeover-modal-wrapper');
		this.scrollPositionWhenLocked = 0;
		this.videoHasBeenStarted = false;
		this.init();
	}

	init() {
		/* If the dino isn't visible, i.e. we don't want to output the takeover, return */
		if (!this.dino) {
			return;
		}

		/* Check if the user has closed the Dino takeover. If they have, don't display it again */
		var dinoCookieClosed = $.cookie('dino_takeover_closed');
		if (dinoCookieClosed) {
			return;
		}

		/* Shake screen */
		window.setTimeout(() => {
			document.querySelector('.site-wrapper').classList.add('shake-screen-alt');
		}, 8000);

		/* Animate dino enter */
		window.setTimeout(() => {
			if (this.dino) {
				this.dino.classList.add('enter');
			}
		}, 10000);

		/* Fade in modal */
		window.setTimeout(() => {
			if (this.modalWrapper) {
				//jQuery('.dino-takeover-modal-wrapper').fadeIn(1000);

				/* Scroll lock the body element */

				/*
				//window.dinoTakeover.scrollPositionWhenLocked = $(window).scrollTop();
				$('body').css('position', 'fixed');
                */
				jQuery('.dino-takeover-modal-wrapper').addClass('visible');
			}
		}, 12500);

		$('.dino-takeover-modal-close').on('click', function (event) {
			event.preventDefault();

			/* Scroll the user to their old position */
			//$('body').css('position', 'static');
			//$(window).scrollTop(window.dinoTakeover.scrollPositionWhenLocked);

			$.cookie('dino_takeover_closed', 'true', { expires: 4, path: '/' });
			jQuery('.dino-takeover-modal-wrapper').fadeOut(500);
			window.setTimeout(function () {
				jQuery('.dino-takeover-modal-wrapper').removeClass('visible');
			}, 500);
			/* Stop the video from playing */
			var video = $('.dino-takeover-video-wrapper').find('video');
			video[0].pause();
		});

		/* When the video is played for the first time, push an event to Google Analytics */
		var videoElement = document.querySelector('.dino-takeover-video-wrapper video');
		videoElement.addEventListener('play', (event) => {
			if (!window.dinoTakeover.videoHasBeenStarted) {
				/* Remove our custom play button */
				$('.dino-takeover-btn').slideUp(300);

				__gaTracker('send', 'event', {
					eventCategory: 'Video play',
					eventAction: 'play',
					eventLabel: 'Extinction video',
					transport: 'beacon',
				});
			}
			window.dinoTakeover.videoHasBeenStarted = true;
		});

		$('.dino-takeover-btn').on('click', function () {
			//var videoWrapper = $('.dino-takeover-video-wrapper');
			var video = $('.dino-takeover-video-wrapper').find('video');

			/* Force scroll to top inside the wrapper */
			$('.dino-takeover-modal-body').scrollTop(0);

			//videoWrapper.slideDown(500);
			video[0].play();
		});
	}
}

window.addEventListener('load', () => {
	window.dinoTakeover = new ProfetDinoTakeover();
});
